import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCcqHUkOXo3i-t4PnZ5Te2XpQ8qhg7xeBY",
  authDomain: "tia-matcher.firebaseapp.com",
  projectId: "tia-matcher",
  storageBucket: "tia-matcher.firebasestorage.app",
  messagingSenderId: "201710686019",
  appId: "1:201710686019:web:1c0f652879e39c488de9f6"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
